<template lang="pug">
  b-card.w-100(no-body)
    .d-flex.align-items-center(slot="header")
      span(style="line-height: 100%;") {{$t('management_page.system_policy')}}
      span.ml-2(@click="showDialog('systemPolicy')") 
        icon(name="question-circle")
    b-list-group
      // 사용자 원격
      b-list-group-item
        b-row.d-flex
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2")
            span {{$t('management_page.user_remote_approval')}}
            span.ml-2(@click="showDialog('paymentProcess')") 
              icon(name="question-circle")
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.flag_function_approval"
                theme="bootstrap"
                :color="form.flag_function_approval ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.disabled_enabled')}})
            .msg
              b-btn(size="sm" @click="showDialog('settingReason')") {{$t('setting')}}
              span.ml-2 {{$t('management_page.remote_request_and_approval')}}
      // 매니저 결재 기능
      b-list-group-item
        b-row.d-flex
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2")
            span {{$t('management_page.manager_registration_approval')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.flag_function_manager_approval"
                theme="bootstrap"
                :color="form.flag_function_manager_approval ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.disabled_enabled')}})
            .msg
              span.ml-2 {{$t('management_page.manager_registration_with_approval')}}
      // 원격기기 결재 기능
      b-list-group-item
        b-row.d-flex
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2")
            span {{$t('management_page.remote_device_registration_approval')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2
              switches.lmm-switch(
                v-model="form.flag_function_agent_approval"
                theme="bootstrap"
                :color="form.flag_function_agent_approval ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.disabled_enabled')}})
            .msg
              span.ml-2 {{$t('management_page.remote_device_registration_with_approval')}}
      b-list-group-item
        b-row
          b-col.d-flex.align-items-center(cols="12" md="12" lg="2")
            span {{$t('blocking-settings')}}
          b-col.d-flex.align-items-center.contents(cols="12" md="12" lg="10")
            .switch.mr-2.nowrap
              switches.lmm-switch(
                v-model="form.enable_ip_policy",
                theme="bootstrap",
                :color="form.enable_ip_policy ? 'warning' : 'default'"
              )
              span.ml-2 ({{$t('management_page.disabled_enabled')}})
            .msg
              span {{$t('management_page.internal_network_admin_ip_management')}}
    
    dialog-system-policy(:show.sync="show.systemPolicy")
    dialog-payment-process(:show.sync="show.paymentProcess")

    dialog-setting-reason(:show.sync="show.settingReason")
</template>

<script>
import Switches from "vue-switches"
import DialogSystemPolicy from "./dialog/dialogSystemPolicy.vue"
import DialogPaymentProcess from "./dialog/dialogPaymentProcess.vue"

import DialogSettingReason from "./dialog/dialogSettingReason.vue"

export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          file_transfer: false,
          partner_remote: false,
          email_remote: false,
          ip_management: false,
        }
      },
    },
  },
  components: {
    Switches,
    DialogSystemPolicy,
    DialogPaymentProcess,

    DialogSettingReason,
  },
  watch: {
    "form.flag_function_approval"(val) {
      this.$emit("updateToggle", "flag_function_approval", val)
    },
    "form.flag_function_manager_approval"(val) {
      this.$emit("updateToggle", "flag_function_manager_approval", val)
    },
    "form.flag_function_agent_approval"(val) {
      this.$emit("updateToggle", "flag_function_agent_approval", val)
    },
    "form.enable_ip_policy"(val) {
      this.$emit("updateToggle", "enable_ip_policy", val)
    },
  },
  data() {
    return {
      show: {
        systemPolicy: false,
        paymentProcess: false,

        settingReason: false,
      },
    }
  },
  methods: {
    showDialog(type) {
      this.show[type] = true
    },
    // notUse() {
    //   this.$awn.alert("미구현 정책입니다.")
    // },
  },
}
</script>

<style lang="scss" scoped>
.nowrap {
  white-space: nowrap;
}
</style>
